<div class="zk-flex zk-flex-col zk-gap-3 zk-p-10">
  <p class="insights-title" freud-typography fontType="h2BoldAuto">
    {{ 'INSIGHTS.TITLE' | translate }}
  </p>
  <div>
    <iframe
      #iframeRef
			*ngIf="!isSupersetEnabled"
      id="looker-insights-iframe"
      alt="dashboard"
      [src]="iframeUrl | safe: 'resourceUrl'"
      style="width: 100%; height: 68vh;"
    >
    </iframe>
  </div>
	<superset-embed
		*ngIf="dashboard && isSupersetEnabled"
		[dashboard]="dashboard"
		messageLoading="{{
				'INSIGHTS.REPORT_MESSAGE_LOADING' | translate
			}}"
		heightIframeVh="68"
	></superset-embed>
  <insights-clari-sugestions></insights-clari-sugestions>
</div>
